module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch1"
    }
  }, [_vm._v("What Makes the Dalai Lama Lovable?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("His posture")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("From so many years")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Holding his robe with one hand")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Is odd.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("His gait")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Also.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("One’s own body")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Aches")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Witnessing")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("The sloping")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Shoulders")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("& Angled")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Neck;")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("One hopes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("He")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Attends")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Yoga class")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Or does Yoga")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("On his own")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("As part")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Of prayer.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("He smiles")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("As he bows")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("To Everything:")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Accepting")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("The heavy")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Burdens")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Of")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("This earth;")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("Its")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Toxic")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Evils")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("& Prolific")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Insults.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("Even so,")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("He sleeps")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Through")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("The night")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Like a child")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Because")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Thank goodness")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("That is something")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Else")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Daylong")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Meditation")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Assures.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("You could cry")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Yourself to sleep")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("On his behalf")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("& He")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Has done that")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Too.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Has been")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("A great")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Endless")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Tearing away")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("For")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Him.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("From")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Mother, Father, Siblings, Country, Home.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("And yet")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Clearly")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("His mother")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Loved him;")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("His brother & sister")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Too: Even his")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Not so constant father,")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Who")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("When Tenzin was")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("A boy")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Shared")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("With him")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Delicious")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Scraps")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Of")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Succulent")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Pork.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("He laughs")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Telling this")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Over half a century")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Later")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("&")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("To who knows")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("How many")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Puzzled")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Vegetarians:")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("About")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("The way he sat")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Behind")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("His father’s chair")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Like a dog,")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Relishing")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Each juicy")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Greasy")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Bite.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Whenever I see")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("The Dalai Lama")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("My first impulse")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Is to laugh")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("I am so happy")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("To")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Lay eyes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("On")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("One")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("So effortlessly")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Beautiful.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("That balding head")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("That holds")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("A shine;")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Those wire framed")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Glasses")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("That might")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Have come")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("From")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Anywhere.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("That look of having offered")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_c('i', [_vm._v("All he has.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("He is my teacher;")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Just staying alive.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Other teachers")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("I have had")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Resemble him")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("In some way;")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("They too")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Were")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("&")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Are")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Smart")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("And Humble;")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Fascinated")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("By Science & things like")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Time,")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Eternity,")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Cause & Effect;")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("The Evolution")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Of the Soul.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("A")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Soul")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("That")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Might")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Or might not")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Exist.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("They too")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("See all of us")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("—Banker, murderer, gardener, thief—")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("When they look")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Out across")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("The world:")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("But that is not all")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("They see.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("They see our suffering;")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Our striving")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("To find")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("The right path;")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("The one with heart")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("We may only")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Have heard about.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("The Dalai Lama is Cool")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("A modern word")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("For")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("“Divine”")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Because he wants")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Only")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Our collective")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Health")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("& Happiness.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_c('i', [_vm._v("That")]), _vm._v("’"), _c('i', [_vm._v("s it")]), _vm._v("!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp1"
  }, [_c('span', [_c('span', [_vm._v("What makes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Him")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Lovable")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("Is")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('span', [_c('span', [_vm._v("His holiness.")])])]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_c('span', [_c('span', [_vm._v("*"), _c('span', {
    staticClass: "spaces"
  }), _vm._v("*"), _c('span', {
    staticClass: "spaces"
  }), _vm._v("*")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c63ad10a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter001.vue
// module id = 78
// module chunks = 0